enum Role {
  User = "User",
  Admin = "Admin",
  Owner = "Owner",
  Customer = "Customer",
  Interpreter = "Interpreter",
  SignLanguage = 'SignLanguage'
}
export default Role;
